export default '/build/6add3008.jpg'